import React, { useState, useEffect } from 'react'
import Topbar from '../components/Layout/Topbar'
import { Sidebar } from '../components/Layout/Sidebar'
import WarehouseArea from '../components/ManageWarehouse/WarehouseArea'
import CreateWarehouse from '../components/ManageWarehouse/CreateWarehouse'
import { supabase } from '../supabase.config'
import { getUsersByRole } from '../supabase.config'
import { useSelector } from 'react-redux'
const ManageWarehouse = () => {

    const [warehouseModal, setWarehouseModal] = useState(false)
    const [warehouseList, setWarehouseList] = useState([])
    const [userList, setuserList] = useState([])
    const { error, loading, isAuthenticated, users, userProfile } = useSelector(
        (state) => state.user
    );

    const handleWarehouseModal = () => {
        setWarehouseModal(!warehouseModal)
    }
    const deleteWarehouse = async (id) => {
        const { error } = await supabase
          .from('warehouses')
          .delete()
          .eq('id', id)
        if (error) {
          console.error('Failed to delete warehouse', error)
          alert('Failed to delete warehouse: ' + error.message)
          return
        }
        // Refresh list
        setWarehouseList((prev) => prev.filter(w => w.id !== id))
    }
    const [pickupName, setPickupName] = useState({})
    const [warehouseData, setWarehouseData] = useState({

        pinCode: "",
        city: "",
        state: "",
        country: "",
        address: "",
        personName: "",
        email: "",
        phone: "",
        slot: ""
    })
    const handleWarehouse = async () => {
        if (Object.keys(pickupName).length === 0) {
            alert("Please enter the PickUp Name")
        }
        else if (warehouseData.pinCode.length === 0) {
            alert("Please enter the Pin Code")
        }
        else if (warehouseData.city.length === 0) {
            alert("Please enter the City name")
        }
        else if (warehouseData.state.length === 0) {
            alert("Please enter the State name")
        }
        else if (warehouseData.country.length === 0) {
            alert("Please enter the Country name")
        }
        else if (warehouseData.address.length === 0) {
            alert("Please enter the Address")
        }
        else if (warehouseData.personName.length === 0) {
            alert("Please enter the Person name")
        }
        else if (warehouseData.email.length === 0) {
            alert("Please enter the Person name")
        }
        else if (warehouseData.phone.length === 0) {
            alert("Please enter the Phone Number")
        }
        else if (warehouseData.slot.length === 0) {
            alert("Please enter the Slot")
        }
        else {
            // Insert into Supabase warehouses table
            const name = pickupName?.name || pickupName?.companyName || 'Warehouse'
            const address = warehouseData.address
            const payload = {
              name,                       // warehouse name/label
              company_name: pickupName?.companyName || '',
              pin_code: warehouseData.pinCode,
              city: warehouseData.city,
              state: warehouseData.state,
              country: warehouseData.country,
              address,                   // street address
              contact_person: warehouseData.personName,
              contact_number: warehouseData.phone,
              preferred_slot: warehouseData.slot,
              status: 'active',
      
            }
            let created
            {
              const { data, error } = await supabase
                .from('warehouses')
                .insert([payload])
                .select()
              if (error) {
                // Retry without new columns if DB not migrated yet
                if (/column .* does not exist|schema cache/i.test(error.message)) {
                  console.warn('Warehouses schema missing new columns, retrying with minimal payload...')
                  const minimal = {
                    name,
                    address,
                    contact_person: warehouseData.personName,
                    contact_number: warehouseData.phone,
                    status: 'active',
                    user_id: pickupName?.id || null
                  }
                  const retry = await supabase
                    .from('warehouses')
                    .insert([minimal])
                    .select()
                  if (retry.error) {
                    console.error('Failed to create warehouse (retry failed)', retry.error)
                    alert('Failed to create warehouse: ' + retry.error.message)
                    return
                  }
                  created = retry.data?.[0]
                } else {
                  console.error('Failed to create warehouse', error)
                  alert('Failed to create warehouse: ' + error.message)
                  return
                }
              } else {
                created = data?.[0]
              }
            }
            // Update local list with a mapped object compatible with table
            const mapped = {
              id: created.id,
              pickupName: { name: pickupName?.name, companyName: pickupName?.companyName },
              pinCode: warehouseData.pinCode,
              city: warehouseData.city,
              state: warehouseData.state,
              country: warehouseData.country,
              address: warehouseData.address,
              personName: warehouseData.personName,
              email: warehouseData.email,
              phone: warehouseData.phone,
              slot: warehouseData.slot,
              userUid: pickupName?.uid
            }
            setWarehouseList((prev) => [mapped, ...prev])
            setWarehouseData({
                pinCode: "",
                city: "",
                state: "",
                country: "",
                address: "",
                personName: "",
                email: "",
                phone: "",
                slot: ""
            })
            setPickupName({})
            setWarehouseModal(!warehouseModal)
        }

    }

    const fetchWarehouse = async () => {
        const { data, error } = await supabase
          .from('warehouses')
          .select('*')
          .order('created_at', { ascending: false })
        if (error) {
          console.error('Failed to fetch warehouses', error)
          return
        }
        // Map to UI shape expected by WarehouseTable
        const mapped = (data || []).map(w => ({
          id: w.id,
          pickupName: { name: w.name, companyName: w.company_name || '' },
          pinCode: w.pin_code || '',
          city: w.city || '',
          state: w.state || '',
          country: w.country || '',
          address: w.address || '',
          personName: w.contact_person || '',
          email: '',
          phone: w.contact_number || '',
          slot: w.preferred_slot || ''
        }))
        setWarehouseList(mapped)
    }
    const fetchUsers = async () => {
        const { data, error } = await getUsersByRole('client', 'logistics')
        if (error) {
          console.error('Failed to fetch users for autocomplete', error)
          return
        }
        const users = (data || []).map(u => ({
          id: u.id,
          name: u.name,
          email: u.email,
          companyName: u.company_name,
          uid: u.id
        }))
        setuserList(users)
    }
    console.log(pickupName)

    useEffect(() => {
        fetchWarehouse()
        fetchUsers()
    }, [])



    console.log(userList)
    return (
        <div className='flex bg-slate-100/80'>
            {/* <EditWarehouse userList={userList} pickupName={pickupName} setPickupName={setPickupName} UpdateWarehouse={UpdateWarehouse} warehouseData={warehouseData} setWarehouseData={setWarehouseData} editWarehouse={editWarehouse} handleeditWarehouseModal={handleeditWarehouseModal} setEditWarehouse={setEditWarehouse} /> */}
            <CreateWarehouse userList={userList} pickupName={pickupName} setPickupName={setPickupName} handleWarehouse={handleWarehouse} warehouseData={warehouseData} setWarehouseData={setWarehouseData} warehouseModal={warehouseModal} handleWarehouseModal={handleWarehouseModal} setWarehouseModal={setWarehouseModal} />
            <Sidebar />
            <div className='flex h-[100vh] flex-1 flex-col overflow-y-scroll' >
                <Topbar />

                <WarehouseArea deleteWarehouse={deleteWarehouse} userList={userList} pickupName={pickupName} setPickupName={setPickupName} warehouseList={warehouseList} warehouseModal={warehouseModal} handleWarehouseModal={handleWarehouseModal} setWarehouseModal={setWarehouseModal} />
            </div>
        </div>
    )
}

export default ManageWarehouse
